import { generateSeoProps } from '../generateSeoProps';
export const getContactUsSeoProps = () => {
	return generateSeoProps({ title: 'Pharmuni | Contact Us', canonical: 'contact-us' });
};
